export const formatDate = (date: Date): string => {
  const pad = (n: number) => n.toString().padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day} - ${hours}:${minutes}`;
};

export const formatInvoiceDate = (date: string): string => {
  const dateTime = new Date(date);
  let day = String(dateTime.getDate()).padStart(2, "0");
  let month = String(dateTime.getMonth() + 2).padStart(2, "0");
  let year = dateTime.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatInvoiceTime = (time: string): string => {
  const dateTime = new Date(`2000-01-01T${time}`);
  let hours = dateTime.getHours();
  let minutes = String(dateTime.getMinutes()).padStart(2, "0");
  let period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${String(hours).padStart(2, "0")}:${minutes} ${period}`;
};
